exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-truncatedText{overflow:hidden;white-space:nowrap;width:100%;display:table;table-layout:fixed;text-decoration:inherit}.ba-common-truncatedText__text{white-space:nowrap;line-height:normal;display:inline-block;text-decoration:inherit}.ba-common-truncatedText__tooltip{width:100%}.ba-common-truncatedText.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-truncatedText.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-truncatedText{transition:opacity .2s ease-in-out}.ba-common-truncatedText.is-disabled{opacity:.5}.test{font-size:50px;line-height:75px}", ""]);

// exports
exports.locals = {
	"truncatedTextClassName": "\"ba-common-truncatedText\""
};